import Termly from '@components/termly/Termly';
import { ContentBlock } from '@layouts/ContentBlocks';
import Typography from '@mui/material/Typography';
import { useStyles } from '@ui/utils/makeStyles';
import { makeSeoData } from 'config/next-seo.config';
import { NextSeo } from 'next-seo';
import React from 'react';

const title = 'Guest House Privacy Policy';
const description = 'We take your privacy seriously. Here is the privacy policy we use to inform users what to expect and to assure them we will protect their information.';

export default function Privacy() {
  const { theme } = useStyles();

  return (
    <>
      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle: title, metaDescription: description })} />
      <ContentBlock
        margin={[2, 'auto', 3]}
        padding={0}
      >
        <Typography
          variant="h1"
          style={{ position: 'relative', top: 75, marginLeft: theme.spacing(3.5) }}
        >
          Privacy Notice
        </Typography>
        {process.browser && (
          <Termly id="9fa73b02-15e0-4ef5-a47a-a1923e6f30ab" />
        )}
      </ContentBlock>
    </>
  );
}
